import React from "react";
import CallIconDefault from "../../../../svg/call-icon-default";

/** Payload for {@link CallingResolvedPhoneCell} when the row has a resolved calling status. */
export interface CallingResolvedPhoneCellValue {
  /** Text shown on hover (e.g. calling / call reason). */
  tooltip: string;
}

interface CallingResolvedPhoneCellProps {
  value: CallingResolvedPhoneCellValue | null | undefined;
  [key: string]: unknown;
}

/**
 * Renders a green phone icon for resolved calling cases; native tooltip shows the reason.
 *
 * @param value - `{ tooltip }` when resolved; otherwise empty cell
 */
export const CallingResolvedPhoneCell: React.FC<
  CallingResolvedPhoneCellProps
> = ({ value }) => {
  if (!value || typeof value !== "object" || !("tooltip" in value)) {
    return (
      <div className="flex min-h-[20px] min-w-[20px] items-center justify-center" />
    );
  }

  const title = value.tooltip?.trim() ? value.tooltip : undefined;

  return (
    <div
      className="flex cursor-default items-center justify-center"
      title={title}
    >
      <CallIconDefault strokeColor="#16a34a" />
    </div>
  );
};

export default CallingResolvedPhoneCell;
